<template>
  <ModalCard>
    <template #header>
      <SkeletonView :height="100" />
    </template>
    <template #body>
      <SkeletonView :height="30" />
      <div class="columns py-3">
        <div class="column is-8">
          <div v-for="i in 3" :key="i" class="py-3">
            <SkeletonView :height="15" />
          </div>
        </div>
      </div>
      <SkeletonView :height="50" />
    </template>
  </ModalCard>
</template>

<script>
import ModalCard from '@/modules/core/ui/components/ModalCard.vue';
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'CheckoutSessionAddonCardSkeleton',
  components: { SkeletonView, ModalCard }
};
</script>
